/* unplugin-vue-components disabled */import script from "./InvoiceCapacityLedger.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceCapacityLedger.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__